module.exports = __webpack_public_path__ + "img/9.c1c4313d.png";